import React, { Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { AppBar, Avatar, Toolbar, Tooltip, IconButton, ClickAwayListener, Typography, Box } from '@material-ui/core';
import HeaderImage from '../Icons/enphase-logo.png';
import settings from '../../../utils/settings';
import clsx from 'clsx';
import MenuIcon from '@material-ui/icons/Menu';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Account from '../Icons/Account';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import User from '../Icons/User';
import { removeKey } from '../../../utils/localStorage';
import I18n from '../../../config/locales';

const LightTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.secondary.main,
    color: '#0F0F0F',
    borderRadius: 0,
    boxShadow: theme.shadows[1],
    fontSize: 11,
    padding: theme.spacing(1),
    top: theme.spacing(-1),
    minWidth: theme.spacing(30),
    pointerEvents: 'auto'
  },
  arrow: {
    color: theme.palette.secondary.main
  }
}))(Tooltip);

const styles = theme => ({
  root: {
    display: 'flex',
    background: theme.palette.primary.main,
    flexDirection: 'row',
    boxShadow: 'none',
    zIndex: 11,
    position: 'fixed'
  },
  large: {
    width: theme.spacing(15),
    height: 'auto'
  },
  toolbar: {
    padding: 0,
    minHeight: 0
  },
  headerToolbar: {
    margin: theme.spacing(0, 4)
  },
  mobileToolbar: {
    padding: 0,
    minHeight: 0,
    flexDirection: 'row-reverse',
    flexGrow: 1
  },
  menuIcon: {
    cursor: 'pointer',
    color: theme.palette.secondary.main
  },

  fullList: {
    width: theme.spacing(25),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%'
  },
  rightSection: {
    marginLeft: 'auto',
    padding: 0,
    minHeight: 0
  },

  iconButton: {
    padding: 0,
    marginRight: theme.spacing(4.5),
    borderRadius: 0,
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  userWrapper: {
    display: 'flex',
    alignItems: 'center',
    background: '#EAEAEA 0% 0% no-repeat padding-box',
    padding: theme.spacing(1, 2)
  },
  user: {
    color: '#0F0F0F',
    fontSize: 20
  },
  userIcon: {
    width: theme.spacing(9),
    height: theme.spacing(9)
  },
  link: {
    fontSize: 16,
    color: theme.palette.tertiary.main,
    padding: theme.spacing(1),
    borderBottom: '1px solid #70707036',
    '&:last-child': {
      border: 'none'
    }
  },
  accountWrapper: {
    marginTop: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column'
  },
  logout: {
    fontSize: 16,
    color: '#0f0f0f9e',
    cursor: 'pointer'
  },
  accountRoot: {
    display: 'flex',
    flexDirection: 'column'
  },
  mobileUserWrapper: {
    order: 1,
    flexDirection: 'column'
  },
  mobileAccountWrapper: {
    order: 0
  },
  userDetails: {
    marginLeft: theme.spacing(2)
  },
  mobileUserDetails: {
    marginLeft: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  mobileAccountDetailsLink: {
    border: 'none',
    borderTop: '1px solid #70707036',
    '&:last-child': {
      borderTop: '1px solid #70707036'
    }
  }
});

class HeaderWithLogo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      accountDropdownOpen: false,
      subMenu: { account: false, services: false, dataPrivacy: false, support: false }
    };
  }

  handleAccountDropdown = isOpen => {
    this.setState({ accountDropdownOpen: isOpen });
  };

  toggleDrawer() {
    this.setState({ open: !this.state.open });
  }

  redirect(menu) {
    const url = settings.enlightenMenuUrl(menu);
    window.location.replace(url);
  }

  accountDetails = (isMobile = false) => {
    const { classes, accountDetail } = this.props;
    const { first_name: firstname, last_name: lastname } = accountDetail;

    let rootClass = '';
    let userWrapper = classes.userWrapper;

    let userDetails = classes.userDetails;

    if (isMobile) {
      rootClass = classes.accountRoot;
      userWrapper = clsx(userWrapper, classes.mobileUserWrapper);

      userDetails = classes.mobileUserDetails;
    }
    return (
      <Box className={rootClass}>
        <Box className={userWrapper}>
          <User className={classes.userIcon} />
          <Box className={userDetails}>
            <Typography className={classes.user}>{`${firstname} ${lastname}`}</Typography>
            <Typography
              className={classes.logout}
              component="div"
              onClick={() => {
                removeKey('_enlighten_manager_token');
                removeKey('_solargraf_token');
                removeKey('referrer');
                this.redirect('logout');
              }}
            >
              {I18n.t('header.logOut')}
            </Typography>
          </Box>
        </Box>
      </Box>
    );
  };

  renderSideList() {
    const { classes } = this.props;
    return (
      <div className={classes.fullList} role="presentation">
        {this.accountDetails(true)}
      </div>
    );
  }

  render() {
    const { classes, isMobileView } = this.props;
    return (
      <Fragment>
        <AppBar position="static" color="secondary" className={classes.root}>
          <Toolbar className={clsx(classes.headerToolbar, classes.toolbar)}>
            <Avatar variant="square" alt="enphase logo" src={HeaderImage} className={classes.large} />
          </Toolbar>
          {isMobileView ? (
            <Toolbar className={classes.mobileToolbar}>
              <IconButton className={classes.iconButton} onClick={() => this.toggleDrawer()}>
                <MenuIcon className={classes.menuIcon} />
              </IconButton>
            </Toolbar>
          ) : (
            <Fragment>
              <Toolbar className={classes.rightSection}>
                <ClickAwayListener onClickAway={() => this.handleAccountDropdown(false)}>
                  <LightTooltip
                    onClose={() => this.handleAccountDropdown(false)}
                    open={this.state.accountDropdownOpen}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    title={this.accountDetails()}
                    arrow
                    placement="bottom-end"
                  >
                    <IconButton
                      className={clsx(classes.iconButton, classes.menuIcon)}
                      onClick={() => this.handleAccountDropdown(!this.state.accountDropdownOpen)}
                    >
                      <Account />
                      {this.state.accountDropdownOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </IconButton>
                  </LightTooltip>
                </ClickAwayListener>
              </Toolbar>
            </Fragment>
          )}
        </AppBar>
        {isMobileView && (
          <SwipeableDrawer
            anchor="right"
            open={this.state.open}
            onClose={() => this.toggleDrawer()}
            onOpen={() => this.toggleDrawer()}
          >
            {this.renderSideList()}
          </SwipeableDrawer>
        )}
      </Fragment>
    );
  }
}
export default withStyles(styles)(HeaderWithLogo);
